export default {
  ui: {
    dialog: {
      confirm: "Confirm",
      cancel: "Cancel",
      title: {
        dialog: "Dialog box",
        alert: "Alert box",
        confirm: "Confirm box",
        prompt: "Prompt box",
      },
    },
    cascader: {
      pathAllLabel: "All",
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Please select",
    },

    pagination: {
      goto: "Go to",
      pageSize: "/page",
      total: "Total {total}",
      pageClassifier: "",
    },

    colorpicker: {
      confirm: "OK",
      clear: "Clear",
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      // week: 'week',
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
      },
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      shortcuts: {
        today: "Today",
        yesterday: "Yesterday",
        thisWeek: "This week",
        lastWeek: "Last week",
        nextWeek: "Next week",
        thisMonth: "This month",
        lastMonth: "Last month",
        nextMonth: "Next month",
        thisQuarter: "This quarter",
        lastQuarter: "Last quarter",
        nextQuarter: "Next quarter",
        thisYear: "This year",
        lastYear: "Last year",
      },
      format: {
        year: "yyyy",
        month: "MMMM yyyy",
        date: "dd MMMM yyyy",
        dateTime: "dd MMMM yyyy HH:mm:ss",
      },
      separator: " to ",
    },
    selector: {
      placeholder: "Please select",
      multiplePlaceholder: "Select More...",
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
    },

    autoComplete: {
      placeholder: "Please enter a keyword to search",
    },

    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input",
    },
    upload: {
      delete: "Delete",
      dragAndDrop: "Drag file here and drop, or",
      click: "Click here",
      clickUpload: "Click to upload",
      startUpload: "Start upload",
      preview: "Preview",
      fail: "Upload failed",
      cancel: "Cancel",
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum",
    },
    tree: {
      emptyText: "No Data",
    },

    treeSelect: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
    },

    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"], // to be translated
      filterPlaceholder: "Enter keyword", // to be translated
      noCheckedFormat: "{total} items", // to be translated
      hasCheckedFormat: "{checked}/{total} checked", // to be translated
    },

    colorPicker: {
      confirm: "Confirm",
      reset: "Reset",
    },
    popconfirm: {
      confirm: "Confirm",
      cancel: "Cancel",
    },
  },
}
